import React from 'react';
import ErrorPageIcon from '../../assets/ErrorPageIcon';
import {
  ErrorCaption,
  PhoneNumber,
  ErrorTextTwo,
  NoWrap,
  LeftErrorWrapper,
  UpdateErrorWrapper,
  LeftErrorText,
  UpdateErrorText,
  OvpErrorCaption,
  OvpErrorWrapper,
  OvpErrorText,
} from './Error.styles';

const Error = (props: { screen: any }) => {
  const { screen } = props;

  const LeftError = () => {
    return (
      <LeftErrorWrapper>
        <ErrorPageIcon />
        <ErrorCaption data-testid="error-page-title">
          Oops, something weird happened here.
        </ErrorCaption>
        <LeftErrorText data-testid="error-page-body">
          We got a little lost on our way to deliver you an amazing ownership
          experience.
        </LeftErrorText>
        <ErrorTextTwo data-testid="error-page-contact-text">
          Please try again, or contact us at{' '}
          <PhoneNumber>1-800-333-4554</PhoneNumber> or via chat, in the{' '}
          <NoWrap> bottom-right corner.</NoWrap>
        </ErrorTextTwo>
      </LeftErrorWrapper>
    );
  };

  const UpdateError = () => {
    return (
      <UpdateErrorWrapper>
        <ErrorPageIcon />
        <ErrorCaption data-testid="error-page-title">
          Oops, something weird happened here.
        </ErrorCaption>
        <UpdateErrorText data-testid="error-page-body">
          We got a little lost on our way to deliver you an amazing ownership
          experience.
        </UpdateErrorText>
        <ErrorTextTwo data-testid="error-page-contact-text">
          Please try again, or contact us at{' '}
          <PhoneNumber>1-800-333-4554</PhoneNumber> or via chat, in the{' '}
          <NoWrap> bottom-right corner.</NoWrap>
        </ErrorTextTwo>
      </UpdateErrorWrapper>
    );
  };

  const OvpError = () => {
    return (
      <OvpErrorWrapper>
        <ErrorPageIcon />
        <OvpErrorCaption data-testid="error-page-title">
          Oops, something weird happened here.
        </OvpErrorCaption>
        <OvpErrorText data-testid="error-page-body">
          We got a little lost on our way to deliver you an amazing ownership
          experience.
        </OvpErrorText>
        <ErrorTextTwo data-testid="error-page-contact-text">
          Please try again, or contact us at{' '}
          <PhoneNumber>1-800-333-4554</PhoneNumber> or via chat, in the{' '}
          <NoWrap> bottom-right corner.</NoWrap>
        </ErrorTextTwo>
      </OvpErrorWrapper>
    );
  };

  return (
    <>
      {screen === 'left' && <LeftError />}
      {screen === 'update' && <UpdateError />}
      {screen === 'ovp' && <OvpError />}
    </>
  );
};

export default Error;
